module.exports = __webpack_public_path__ + "static/media/abu-dhabi-commercial-bank.88a1e97b.svg";